<ng-select
  id="transactionCategory"
  [(ngModel)]="selectedCategory"
  (ngModelChange)="onCategoryChange($event)"
  [searchable]="searchable()"
  [items]="categories()"
  [readonly]="readonly()"
  notFoundText="No categories available"
  bindLabel="name"
  bindValue="id"
  [clearable]="clearable()"
  [class.is-invalid]="errorMessage()"
  [placeholder]="placeholder()">
  <ng-template
    ng-label-tmp
    let-item="item">
    <span [ngClass]="{ 'text-disabled': !item.is_visible }">{{ item.name }}</span>
  </ng-template>
</ng-select>
